module.exports = __webpack_public_path__ + "img/my-roadpursuit-02.1aa9f4f6.jpg";